<div class="row">
  <div class="col">
    <mat-form-field class="mb-2" appearance="fill" style="width: 100%">
      <mat-label>{{ numberSection.label }}</mat-label>
      <input
        data-testid="notices_add_notice_input_title"
        type="number"
        matInput
        [formControl]="control"
        [required]="numberSection.isRequired"
        placeholder="{{ numberSection.placeholder }}"
      />

      <mat-error *ngIf="control.hasError('required')"
        >{{ numberSection.label }}&nbsp;{{
          'workflow.request-document.basic-details.required-error' | translate
        }}</mat-error
      >
    </mat-form-field>
  </div>
</div>
